import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Fab, useTheme } from '@mui/material';
import { noop } from 'lodash';

import BundleCourseDetail from './BundleCourseDetail';
import BundleCoursePanel from './bundleCoursePanel';

import BaseModalWrapper from '@components/share/modal/baseModalWrapper';
import { useBreakpointV2 } from '@helpers/use';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleCourseItemModalProps = {
  open: boolean;
  onClose: typeof noop;
  bundleDetailSeo: BundleEntity;
  currentIndex: number;
  setCurrentIndex: (currentIndex: number) => void;
};

const BundleCourseItemModal = ({
  open,
  onClose,
  bundleDetailSeo,
  currentIndex,
  setCurrentIndex,
}: BundleCourseItemModalProps) => {
  const handleCloseCourseModal = () => {
    onClose();
  };

  const theme = useTheme();
  const { isMobile, isTablet } = useBreakpointV2();
  const isFullscreen = isMobile || isTablet;

  return (
    <>
      <BaseModalWrapper
        open={open}
        onClose={onClose}
        maxWidth={1136}
        disabledBackDrop
        hideCloseButton
        keepMounted={false}
        fullScreen={isFullscreen}
        paperStyle={{
          width: '100%',
          overflow: 'hidden',
          padding: 0,
          maxHeight: { lg: 'calc(100vh - 122px)' },
        }}
      >
        <BundleCoursePanel currentIndex={currentIndex} setCurrentIndex={setCurrentIndex} />
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: '96px',
            background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.62) 16.32%, rgba(0, 0, 0, 0.00) 100%)',
            zIndex: 8888,
          }}
        />
        <Fab
          onClick={handleCloseCourseModal}
          sx={{
            position: 'fixed',
            right: { xs: 13, md: 18, lg: 27 },
            top: { xs: 22, md: 34, lg: 22 },
            height: { xs: '40px', md: '60px', lg: '70px' },
            width: { xs: '40px', md: '60px', lg: '70px' },
            color: 'white',
            bgcolor: 'rgba(0, 0, 0, 0.35)',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
            zIndex: 9999,
          }}
        >
          <CloseIcon sx={{ color: theme.palette.textOnPrimary.primary, fontSize: { xs: '20px', md: '36px' } }} />
        </Fab>
        <Box
          sx={{
            px: { md: 0, lg: 12 },
            py: { xs: 5, md: '66px', lg: 8 },
          }}
        >
          <BundleCourseDetail bundleDetailSeo={bundleDetailSeo} />
        </Box>
      </BaseModalWrapper>
    </>
  );
};

export default BundleCourseItemModal;
